// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Dg7","fullView":"styles_fullView__3qBhi"};